import React from 'react'
import { CollapickForm } from '@collapick/form';
import useCustomersSchema from '../../FormSchemas/useCustomersSchema'
import { Typography, Grid, Box, Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next';

const CustomersForm = (props) => {
    const { initialValues, title, onSave, onCancel } = props
    const { t } = useTranslation()
    const { customersSchema, customValidators } = useCustomersSchema();

    return (
        <>
            <Grid container justify="center" >
                <Box my={2} >
                    <Typography variant="h2">{title}</Typography>
                </Box>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <CollapickForm
                        formSchema={customersSchema}
                        onFormSubmit={onSave}
                        resetFormAfterSubmit={true}
                        initialValues={initialValues}
                        renderSubmitButton={() =>
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                fullWidth>
                                {t('save')}
                            </Button>}
                        showInvalidSaveButton={true}
                        invalidSubmitText={t("cancel")}
                        onInvalidSubmit={onCancel}
                        customValidators={customValidators}
                    />
                </Grid>
            </Grid>
        </>
    )
}
export default CustomersForm